import Plus from "@/assets/static/plusIcon.svg?url";
import Image from "next/image";
const PlusIcon = () => {
  return <Image width="24" height="24" src={Plus} alt="Plus" />;
};
export default PlusIcon;
